<template>
    <div class="automation-wizard-field-select">
        <CompassSkeleton
            v-if="showSkeleton"
            size="x-large"
            class="automation-wizard-field-select__skeleton"
        />
        <CompassFormItem v-else v-bind="formItemProps" :error="field.currentError || ''">
            <CompassSelect
                v-model="localValue"
                v-bind="selectProps"
                :loading="loading"
                :disabled="disabled"
                menuClass="automation-wizard-field-select"
            >
                <CompassDropdownSelectOption
                    v-for="option in options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                />
            </CompassSelect>
        </CompassFormItem>
    </div>
</template>

<script>
export default {
    name: 'AutomationWizardFieldSelect',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Object],
            default: '',
        },
    },
    emits: ['update:value'],
    data() {
        return {
            options: [],
            loading: false,
            localValue: '',
        };
    },
    computed: {
        formItemProps() {
            return {
                label: this.field.props?.formItem?.label || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
                ...this.field.props?.formItem,
            };
        },
        selectProps() {
            return {
                ...this.field.props?.select,
            };
        },
        disabled() {
            return this.field.disabled || false;
        },
        showSkeleton() {
            return this.loading && this.options.length === 0;
        },
    },
    watch: {
        value: {
            async handler(newValue) {
                this.localValue = newValue || '';
                if (newValue && this.options.length === 0) {
                    await this.loadOptions();
                }
            },
            immediate: true,
        },
        localValue(newValue) {
            this.$emit('update:value', newValue);
        },
    },
    async mounted() {
        await this.loadOptions();
    },
    methods: {
        async loadOptions() {
            try {
                this.loading = true;
                // If "custom" objectType, load options from field.values (no endpoint to call)
                if (this.field.values && Array.isArray(this.field.values)) {
                    this.options = this.field.values.map((item) => ({
                        label: item.value,
                        value: item.key,
                    }));
                } else {
                    this.options = [];
                }
                if (this.value && !this.localValue) {
                    this.localValue = this.value;
                }
            } catch (error) {
                this.options = [];
                throw error;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-field-select {
    &__skeleton {
        width: 100%;
        ::v-deep .compass-skeleton__line--x-large {
            height: 56px;
        }
    }
}
</style>

<style lang="scss">
#compass-dropdown-container {
    .automation-wizard-field-select {
        z-index: 1001;
    }
}
</style>
